export default __webpack_public_path__ + "static/media/asters-play-video.a89aca9f.svg";